import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { Comparativa } from '@shared/models/cierreTurno/Comparativa';

@Component({
  selector: 'app-modal-comparativa',
  templateUrl: './modal-comparativa.component.html',
  styleUrls: ['./modal-comparativa.component.scss']
})
export class ModalComparativaComponent {

  @Input() comparativas: Comparativa[];
  @Input() fechaCierre: string;
  @Input() titulo: string;

  constructor( public activeModal: NgbActiveModal, private excelService: ExportExcelServiceService ) { }

  exportarComparativas(producto: string) { 
    this.excelService.exportAsExcelFile(this.armarArrayExcel(), 'Mediciones '+ producto);
  }
  
  armarArrayExcel() {
    const excelMovimiento: ExcelComparativa[] = [];

    this.comparativas = this.comparativas.sort((a, b) => a.nombreContenedor.localeCompare(b.nombreContenedor));

    for(let i=0; i < this.comparativas.length; i++){
      const item = new ExcelComparativa();
      item.nombreContenedor = this.comparativas[i].nombreContenedor;
      item.existenciaAnterior = this.comparativas[i].existenciaAnterior;
      item.entradas = this.comparativas[i].entradas;
      item.salidas = this.comparativas[i].salidas;
      item.existenciaLibros = this.comparativas[i].existenciaFinal;
      item.existenciaReal = this.comparativas[i].existenciaReal;
      item.diferencia = this.comparativas[i].diferencia;      
      excelMovimiento.push(item);
    }
    return excelMovimiento;
  }
}

export class ExcelComparativa {
  nombreContenedor: string;
  existenciaAnterior: number;
  entradas: number;
  salidas: number;
  existenciaLibros: number;
  existenciaReal: number;
  diferencia: number;
}